module.exports = __webpack_public_path__ + "img/logo5.165c4dc9.png";